// Demo Firehose SSE Client
// No authentication required - replays ~10 stories/minute from 24h prior

import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { demoBaseURL, demoEndpoints } from ".";

const demoSSEClient = new SSEClientManager({
  endpoint: demoBaseURL + demoEndpoints.stream,
  connectionName: "Demo-Firehose-SSE",
  retryEnabled: true,
  cleanupDelayMs: 5000, // Slightly longer cleanup delay for demo
});

export default demoSSEClient;
